import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const token = localStorage.getItem("userToken");

  if (!token) {
    // Redirect to login if the user is not authenticated
    return <Navigate to="/Login" />;
  }

  return <Outlet />; // Render child routes if authenticated
};

export default PrivateRoute;
